module.exports = __webpack_public_path__ + "img/logo.3030db6b.png";